import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, PhoneCall } from 'lucide-react';

const CTA: React.FC = () => {
  return (
    <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-primary-800 via-primary-700 to-primary-600 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_30%,_rgba(255,255,255,0.1)_0%,_transparent_70%)]"></div>
      
      <div className="container mx-auto px-4 md:px-6 text-center relative">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6 bg-gradient-to-r from-white via-gray-100 to-accent-200 bg-clip-text text-transparent">
            Passez à la Mobilité Électrique
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-200 mb-6 sm:mb-8 md:mb-10 leading-relaxed">
            Découvrez nos motos électriques et solutions de recharge adaptées à vos besoins. Nos experts sont là pour vous accompagner dans votre transition vers une mobilité durable.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link 
              to="/products" 
              className="px-4 sm:px-6 md:px-8 py-3 sm:py-4 bg-accent-300 hover:bg-accent-400 text-gray-900 font-medium rounded-md inline-flex items-center justify-center transition-colors shadow-lg hover:shadow-xl transform hover:translate-y-[-2px] text-sm sm:text-base"
            >
              Voir Nos Motos
              <ArrowRight size={18} className="ml-2" />
            </Link>
            <Link 
              to="/contact" 
              className="px-4 sm:px-6 md:px-8 py-3 sm:py-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white font-medium rounded-md inline-flex items-center justify-center transition-colors border border-white/30 transform hover:translate-y-[-2px] text-sm sm:text-base"
            >
              <PhoneCall size={18} className="mr-2" />
              Contactez-Nous
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;